<template>
  <div>
    <catalog-table
      title="Relación Jefes Administrativos - Autopistas"
      :tableHeaders="headers"
      :tableData="filteredRelations"
      :tableFilters="customerFilters"
      :actions="actions"
      :propsToSearch="['name']"
      :pageSize="100"
      hidePageSize
      hideFooter
    >
      <template slot="header">
        <md-field style="width: 320px">
          <label for="highway">Seleccionar cliente*</label>
          <md-select data-vv-name="customer" v-model="customer" name="customer">
            <md-option
              v-for="customer in fetchedCustomers"
              :value="customer.id"
              :key="customer.id"
            >{{ customer.name }}</md-option>
          </md-select>
        </md-field>
      </template>

      <template
        v-if="$can('add', 'Highway', 'administrativechiefs') && customer"
        slot="search-toolbar-actions"
      >
        <md-button class="md-success" :disabled="loadingCatalogs" @click="editModal = true">
          <span class="md-label">
            <md-icon class="material-icons">add</md-icon>
          </span>
          Crear relación
        </md-button>
      </template>
    </catalog-table>
    <!-- -->
    <Edit
      :dialog="editModal"
      :item="currentItem"
      :highways="fetchedHighways"
      :chiefs="fetchedChiefs"
      :relations="filteredRelations"
      @closeDialog="hideEdit"
      @create="createRelation"
      @update="updateRelation"
    ></Edit>
  </div>
</template>

<script>
import catalogService from "@/services/catalog";
import { CatalogTable } from "@/components/";
import { booleanToState } from "@/filters";
import Edit from "./Edit";

export default {
  name: "AdminChiefs",
  components: {
    CatalogTable,
    Edit,
  },

  data() {
    return {
      fetchedRelations: [],
      fetchedChiefs: [],
      fetchedCustomers: [],
      fetchedHighways: [],
      loadingCatalogs: false,
      customer: null,
      editModal: false,
      currentItem: {},
      currentStaff: {},
      headers: {
        chiefName: "Personal",
        highwayName: "Autopista",
      },
      customerFilters: {
        isActive: booleanToState,
      },
      actions: [
        {
          icon: "edit",
          exe: this.editItem,
          showIf: () => this.$can("change", "Highway", "administrativechiefs"),
        },
        {
          icon: "close",
          exe: this.deleteRelation,
          showIf: () => this.$can("delete", "Highway", "administrativechiefs"),
        },
      ],
    };
  },
  computed: {
    filteredRelations() {
      return this.fetchedRelations
        .filter((r) => r.customer === this.customer)
        .sort((a, b) => b.id - a.id);
      // return this.fetchedRelations.filter(r => r.customer === this.customer).sort((a, b) => a.id - b.id)
    },
  },
  methods: {
    editItem(c) {
      this.editModalTitle = "Editar jefe administrativoV";
      this.currentItem = c;
      this.editModal = true;
    },
    createRelation(payload) {
      this.$confirmMessage(
        { text: "Confirme que desea crear esta relación" },
        () => {
          return catalogService
            .create("customer/administrative/highway", payload)
            .then(() => {
              catalogService
                .fetch("customer/administrative/highway")
                .then((res) => {
                  this.fetchedRelations = res;
                });
              this.$successMessage({ text: "Relación creada" });
              this.hideEdit();
            })
            .catch(this.$fireErrorResponse);
        }
      );
    },
    updateRelation(payload) {
      this.$confirmMessage(
        { text: "Confirme que desea modificar esta relación" },
        () => {
          return catalogService
            .update("customer/administrative/highway", payload)
            .then(() => {
              catalogService
                .fetch("customer/administrative/highway")
                .then((res) => {
                  this.fetchedRelations = res;
                });
              this.$successMessage({ text: "Relación modificada" });
              this.hideEdit();
            })
            .catch(this.$fireErrorResponse);
        }
      );
    },
    deleteRelation(payload) {
      this.$confirmMessage(
        { text: "Confirme que desea elimiar esta relación" },
        () => {
          return catalogService
            .delete("customer/administrative/highway", payload)
            .then(() => {
              const findIndex = this.fetchedRelations.findIndex(
                (r) => r.id === payload.id
              );
              this.fetchedRelations.splice(findIndex, 1);
              this.$successMessage({ text: "Relación eliminada" });
            })
            .catch(this.$fireErrorResponse);
        }
      );
    },
    hideEdit() {
      this.editModal = false;
      this.currentItem = {};
    },
  },
  watch: {
    customer(newVal) {
      if (newVal) {
        this.loadingCatalogs = true;
        Promise.all([
          catalogService.fetch(`highway/gethighway/${newVal}`),
          catalogService.fetch(
            `customer/customerstaff/${newVal}/jefe-administrativo`
          ),
        ])
          .then((res) => {
            this.fetchedHighways = res[0];
            this.fetchedChiefs = res[1];
          })
          .catch(this.$fireErrorResponse)
          .finally((this.loadingCatalogs = false));
      }
    },
  },
  mounted() {
    Promise.all([
      catalogService.fetch("customer"),
      catalogService.fetch("customer/administrative/highway"),
    ])
      .then((res) => {
        this.fetchedCustomers = res[0];
        this.fetchedRelations = res[1];
      })
      .catch(this.$fireErrorResponse);
  },
};
</script>

<style lang="css" scoped>
.md-layout {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Customers/AdminChiefs/index.vue